import { render, staticRenderFns } from "./overview-cell-organisation.vue?vue&type=template&id=6de5deff&scoped=true"
import script from "./overview-cell-organisation.vue?vue&type=script&lang=ts"
export * from "./overview-cell-organisation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de5deff",
  null
  
)

export default component.exports